<template>
  <base-container>
    <ArtisanGrid ref="msgRecord" metaKey="JyMsgRecord"> </ArtisanGrid>
  </base-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style>
</style>
